import { Component, ChangeDetectionStrategy, ElementRef, OnInit, Renderer2 } from "@angular/core";
import { AppIcon } from "core/components/icons/icon.type";
import { IconsModule } from "core/components/icons/icons.module";
import { BadgeComponent } from "core/components/badge/badge.component";
import { TipComponent } from "core/components/tip/tip.component";
import { tipAnimation, tipPerspectiveAnimation } from "core/components/tip/tip.animation";
import { RouterLinkActive } from '@angular/router';
import { asyncScheduler } from "rxjs";
import { UpperCasePipe } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { LocaleService } from "src/app/locale/locale.service";
import { RoutesEnum } from "src/app/locale/routes.enum";
import { TouchRouterLinkDirective } from 'core/directives/touch-router-link.directive';

export interface FeatureListData {
  title: string;
  caption: string;
  badge?: { style: string, label: string };
  icon: AppIcon;
  link: RoutesEnum;
}

export type FeaturesTuple = [string, FeatureListData[]][];

@Component({
  selector: 'app-features-list',
  templateUrl: './features-list.component.html',
  styleUrls: ['./features-list.component.scss'],
  standalone: true,
  imports: [IconsModule, BadgeComponent, UpperCasePipe, TranslateModule, TouchRouterLinkDirective, RouterLinkActive],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [tipPerspectiveAnimation],
})
export class FeaturesListComponent extends TipComponent<[string, FeatureListData[]][]> implements OnInit {

  constructor(elementRef: ElementRef<HTMLElement>, public localeService: LocaleService, private renderer: Renderer2) {
    super(elementRef);
  }

  ngOnInit(): void {
    asyncScheduler.schedule(() => {
      this.renderer.addClass(this.elementRef.nativeElement, 'animated');
    }, 100);
  }
}
